import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import logokps from "../images/KPS_logo.png";

function SubjectCombination() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page"> Subject Combinations Class XI Session - 2026-27 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>



            </div>
         <br/>
                   <div className="album py-1">
                <div className="container">
                    <div className="row">
                    <div className="col-md-3">
                           <center>
                          <img src={logokps} height="100px" width="100px" className="img-fluid  rounded-start" alt="kps_logo"/>
</center>
                            </div>
                             <div className="col-md-6">
                            
                                <br/>
                                <br/>
                                <center>
                                <h5 style={{ color: "#1c3a88" }} className='mb-1'><b>KRISHNAGAR PUBLIC SCHOOL</b></h5>
                                <p style={{ color: "#1c3a88" }}><b>Subject Combinations Class XI Session - 2026-27</b></p>
                                </center>
                            </div>
                            </div>
                            </div>
                        </div>
            <div className="album py-1">
                <div className="container">

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th style={{ color: "#1c3a88" }}><small>Choice of Subjects</small></th>
                                <th style={{ color: "#1c3a88" }}>Subject</th>
                                <th style={{ color: "#1c3a88" }}>Remarks</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Subject 1</td>
                                <td>English	</td>
                                <td>Compulsory</td>

                            </tr>
                            <tr>
                                <td>Subject 2</td>
                                <td>Physics /History /Accountancy	</td>
                                <td>Choose any one</td>

                            </tr>
                            <tr>
                                <td>Subject 3</td>
                                <td >Chemistry / Geography / Cost Accounting	</td>
                                <td>Choose any one</td>

                            </tr>


                            <tr>
                                <td>Subject 4</td>
                                <td >Mathematics /Applied Mathematics / Hindi / Bengali / Sociology /
                                    Business Studies	</td>
                                <td>Choose any one</td>

                            </tr>

                            <tr>
                                <td>Subject 5</td>
                                <td >Biology / Economics / Psychology / Computer Science / Banking	</td>
                                <td>Choose any one</td>

                            </tr>

                            <tr>
                                <td>Subject 6</td>
                                <td >Information Technology / Artificial Intelligence / Political Science /
                                    Food, Nutrition & Dietetics	</td>
                                <td>Choose any one</td>

                            </tr>
                            <tr>
                                <td>Subject 7</td>
                                <td >Physical Education / Yoga</td>
                                <td>Choose any one</td>

                            </tr>



                        </tbody>

                    </Table>
                     <p className='mb-1 mt-2'>A candidate needs to have <b>six</b> subjects in total <b>(English plus any five subjects)</b>.</p>
                     <p>A candidate can choose a <b>maximum of two skill subjects</b> from the following list of skill subjects:</p>
                     <p className='mb-0'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg> Information Technology</p>
          <p className='mb-0'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg> Artificial Intelligence</p>
          <p className='mb-0'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg> Food, Nutrition & Dietetics</p>

          <p className='mb-0'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg> Cost Accounting</p>

          <p className='mb-0'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg> Banking</p>

          <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg> Yoga</p>
                </div>
            </div>
        </div>
    )
}

export default SubjectCombination